

import React from "react";
import {useTranslation} from "react-i18next";

export const ContentLoader = () => {
    const {t, i18n} = useTranslation('common');
    return (
        <div className="text-center mt-4">
            <h4>{t("Loading")}</h4>
            <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
        </div>
    )
}